/*global Raven:true*/
import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import { withStyles } from "@material-ui/core/styles"
import { compose } from "recompose"
import styles from "./styles"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import IconButton from "@material-ui/core/IconButton"
import MenuIcon from "@material-ui/icons/Menu"
import Logo from "../../assets/images/adesk_brand.png"
import crewmamaLogo from "../../assets/images/crewmama_brand.png"
import Drawer from "@material-ui/core/Drawer"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import Collapse from "@material-ui/core/Collapse"
import ExpandLess from "@material-ui/icons/ExpandLess"
import ExpandMore from "@material-ui/icons/ExpandMore"
import AccountCircle from "@material-ui/icons/AccountCircle"
import GroupWork from "@material-ui/icons/GroupWork"
import Business from "@material-ui/icons/Business"
import PowerSettings from "@material-ui/icons/PowerSettingsNew"
import Grade from "@material-ui/icons/Grade"
import AddCircle from "@material-ui/icons/AddCircle"
import CardMedia from "@material-ui/core/CardMedia"
import Image from "../../assets/images/login_bg.jpg"
import Divider from "@material-ui/core/Divider"

import { logout } from "../../actions/authentication"
import { openSnackBar } from "../../actions/snack-bar"
import { toggleProfileDialog } from "../../actions/users"
import {
  toggleEditCompanyDialog,
  toggleCreateCompanyDialog,
  switchActiveCompany,
} from "../../actions/companies"
import jwtDecode from "jwt-decode"

import packageJson from "../../../package.json"
import { listCrew } from "../../actions/crew"
import { clearChatters } from "../../actions/message-drawer"
import { getCurrentHost } from "../../utils/getHost"

const { version } = packageJson

class MainAppBarComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      searchTerm: "",
      drawerOpen: false,
      companiesOpen: false,
      companyNames: [],
      userDropdownOpen: false,
      shootsDropdownOpen: false,
      currentPage: 1,
    }

    const companies = props.authentication.authenticatedUser.companies
    const currentCompany = props.companies.activeCompany
    if (companies && Array.isArray(companies)) {
      companies.forEach(company => {
        const companyName =
          "company_" +
          company.name
            .toLowerCase()
            .split(" ")
            .join("_")
        this.state[companyName] = company.id === currentCompany ? true : false
        this.state.companyNames.push(companyName)
      })
    }
  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    })
  }
  toggleDrawer = open => () => {
    if (open && this.props.authentication.authenticatedUser.id) {
      const companies = this.props.authentication.authenticatedUser.companies
      const currentCompany = this.props.companies.activeCompany
      companies.forEach(company => {
        const companyName =
          "company_" +
          company.name
            .toLowerCase()
            .split(" ")
            .join("_")
        this.setState({
          [`${companyName}`]: company.id === currentCompany ? true : false,
        })
      })
    }
    this.setState({
      drawerOpen: open,
    })
  }
  toggleListItem = (name, others = true) => {
    const newState = !this.state[`${name}`]
    this.setState({ [`${name}`]: newState })
    if (newState && others) {
      const companies = this.state.companyNames
      companies.forEach(company => {
        if (name !== company) {
          this.setState({ [`${company}`]: false })
        }
      })
    }
  }
  handleToggleDropdown = name => {
    this.setState({
      [`${name}DropdownOpen`]: !this.state[`${name}DropdownOpen`],
    })
  }

  handleCloseDropdown = (event, name, callback) => {
    if (this[`${name}DropdownTarget`].contains(event.target)) {
      return
    }

    this.setState({ [`${name}DropdownOpen`]: false })

    if (callback) {
      callback()
    }
  }
  doLogout = bool => {
    this.toggleDrawer(false)()
    this.props.dispatch(logout())
    this.props.dispatch(switchActiveCompany(null, ""))
    if (!bool) {
      this.props.dispatch(
        openSnackBar({
          message: "You have been logged out",
        })
      )
    } else {
      this.props.history.push("/login")
    }
  }
  openProfile = () => {
    this.toggleDrawer(false)()
    this.props.dispatch(
      toggleProfileDialog(true, this.props.authentication.authenticatedUser)
    )
  }
  openEditCompany = company => {
    this.toggleDrawer(false)()
    this.props.dispatch(toggleEditCompanyDialog(true, company))
  }
  switchToCompany = company => {
    //this.toggleDrawer(false)()
    this.props.dispatch(
      switchActiveCompany(
        company.id,
        company.managers.find(
          m => m.id === this.props.authentication.authenticatedUser.id
        )
          ? 1
          : 2
      )
    )
    // this.props.dispatch(listCrew())
    // this.props.dispatch(listCrew(this.state.currentPage))
    if (this.props.crew.crew.length === 0) {
      this.props.dispatch(listCrew(this.state.currentPage))
    }

    this.props.dispatch(clearChatters())
  }
  leaveCompany = name => {
    //this.toggleDrawer(false)()
    this.toggleListItem(name)
    this.props.dispatch(switchActiveCompany(null, ""))
    if (this.props.crew.crew.length === 0) {
      this.props.dispatch(listCrew(this.state.currentPage))
    }
    this.props.dispatch(clearChatters())
  }
  getAccessLevel = companyId => {
    let foundCompany
    if (this.props.authentication.token) {
      const decodedToken = jwtDecode(this.props.authentication.token)
      foundCompany = decodedToken.company_data.find(c => c.id === companyId)
    }
    if (foundCompany) {
      return foundCompany.access
    } else {
      return 0
    }
  }
  printMenuCompany = (company, currentCompany = null) => {
    const companyName =
      "company_" +
      company.name
        .toLowerCase()
        .split(" ")
        .join("_")
    const companyId = company.id

    return (
      <Fragment key={companyName}>
        <Divider />
        <ListItem
          button
          onClick={() => this.toggleListItem(companyName)}
          className={
            currentCompany !== null && currentCompany === companyId
              ? this.props.classes.currentCompany
              : ""
          }
        >
          {currentCompany !== null &&
            currentCompany === companyId && (
              <ListItemIcon style={{ minWidth: 0 }}>
                <Grade className={this.props.classes.currentCompanyIcon} />
              </ListItemIcon>
            )}
          <ListItemText
            inset
            primary={company.name}
            classes={
              currentCompany !== null && currentCompany === companyId
                ? { primary: this.props.classes.currentCompanyText }
                : {}
            }
          />
          {this.state[companyName] ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={this.state[companyName]} timeout="auto" unmountOnExit>
          <Divider />
          <List className={this.props.classes.nestedListItem} disablePadding>
            {this.getAccessLevel(company.id) === 1 && (
              <ListItem button onClick={() => this.openEditCompany(company)}>
                <ListItemText inset primary="Manage Organization" />
              </ListItem>
            )}
            {this.getAccessLevel(company.id) === 1 && (
              <Fragment>
                {currentCompany !== null &&
                  currentCompany !== companyId && (
                    <ListItem
                      button
                      onClick={() => this.switchToCompany(company)}
                    >
                      <ListItemText inset primary="Switch To Organization" />
                    </ListItem>
                  )}
                {currentCompany !== null &&
                  currentCompany === companyId && (
                    <ListItem
                      button
                      onClick={() => this.leaveCompany(companyName)}
                    >
                      <ListItemText inset primary="Leave Organization" />
                    </ListItem>
                  )}
              </Fragment>
            )}
          </List>
        </Collapse>
        {/* {(divider) ? <Divider /> : <Fragment></Fragment>} */}
      </Fragment>
    )
  }
  openCreateCompany = () => {
    this.toggleDrawer(false)()
    this.props.dispatch(toggleCreateCompanyDialog(true))
  }
  render() {
    // See SDK documentation for language specific usage.
    Raven.config("https://06de921b059348ef92cff10ca17e2a85@sentry.io/1260193", {
      release: version,
    })
    return (
      <Fragment>
        <Drawer
          open={this.state.drawerOpen}
          classes={{ paper: this.props.classes.drawer }}
          onClose={this.toggleDrawer(false)}
        >
          <div
            tabIndex={0}
            role="button"
            style={{ color: "#000000" }}
            onKeyDown={
              this.toggleDrawer(false) // onClick={this.toggleDrawer(false)}
            }
          >
            <CardMedia className={this.props.classes.media} image={Image}>
              <div className={this.props.classes.mediaContent}>
                <Typography
                  gutterBottom
                  variant="h5"
                  color="inherit"
                  component="h2"
                  className={this.props.classes.cardHeadline}
                >
                  {this.props.authentication.authenticatedUser.first_name}{" "}
                  {this.props.authentication.authenticatedUser.last_name}
                </Typography>
              </div>
            </CardMedia>

            <List>
              {this.props.authentication.authenticatedUser.id ? (
                <React.Fragment>
                  <ListItem button onClick={() => this.openProfile()}>
                    <ListItemIcon>
                      <AccountCircle
                        className={this.props.classes.listItemIcon}
                      />
                    </ListItemIcon>
                    <ListItemText primary="My Profile" />
                  </ListItem>

                  {this.props.authentication.isSuperAdmin && (
                    <ListItem button onClick={this.openCreateCompany}>
                      <ListItemIcon>
                        <AddCircle
                          className={this.props.classes.listItemIcon}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Create Organization" />
                    </ListItem>
                  )}

                  {this.props.authentication.authenticatedUser.companies &&
                    this.props.authentication.authenticatedUser.companies
                      .length > 0 && (
                      <Fragment>
                        {this.props.authentication.authenticatedUser.companies.filter(
                          c =>
                            c.managers.find(
                              m =>
                                m.id ===
                                this.props.authentication.authenticatedUser.id
                            )
                        ).length > 0 && (
                          <ListItem
                            button
                            onClick={() =>
                              this.toggleListItem("companiesOpen", false)
                            }
                          >
                            <ListItemIcon>
                              <Business
                                className={this.props.classes.listItemIcon}
                              />
                            </ListItemIcon>
                            <ListItemText primary="My Organizations" />
                            {this.state.companiesOpen ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </ListItem>
                        )}

                        <Collapse
                          in={this.state.companiesOpen}
                          timeout="auto"
                          unmountOnExit
                        >
                          {/* <Divider /> */}

                          <List
                            className={this.props.classes.nestedListItem}
                            disablePadding
                          >
                            {this.props.authentication.authenticatedUser.companies.map(
                              company =>
                                this.printMenuCompany(
                                  company,
                                  this.props.companies.activeCompany
                                    ? this.props.companies.activeCompany
                                    : 0
                                )
                            )}
                          </List>

                          <Divider />
                        </Collapse>
                      </Fragment>
                    )}

                  <ListItem
                    button
                    onClick={() => {
                      this.toggleDrawer(false)()
                      return this.props.history.push(`/`)
                    }}
                  >
                    <ListItemIcon>
                      <GroupWork className={this.props.classes.listItemIcon} />
                    </ListItemIcon>
                    <ListItemText primary="Crew Profiles" />
                  </ListItem>

                  <ListItem
                    button
                    onClick={() => this.doLogout()}
                    className={this.props.classes.logout}
                  >
                    <ListItemIcon>
                      <PowerSettings
                        className={this.props.classes.listItemIcon}
                      />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                  </ListItem>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  {window.location.pathname !== "/crew" && (
                    <ListItem
                      button
                      onClick={() => {
                        this.toggleDrawer(false)()
                        return this.props.history.push(`/`)
                      }}
                    >
                      <ListItemIcon>
                        <GroupWork
                          className={this.props.classes.listItemIcon}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Crew Profiles" />
                    </ListItem>
                  )}
                  <ListItem
                    button
                    onClick={() => this.doLogout(true)}
                    className={this.props.classes.logout}
                  >
                    <ListItemIcon>
                      <PowerSettings
                        className={this.props.classes.listItemIcon}
                      />
                    </ListItemIcon>
                    <ListItemText primary="Login / Register" />
                  </ListItem>
                </React.Fragment>
              )}
            </List>
          </div>
        </Drawer>
        {/* <header> */}
        <AppBar
          style={{ position: "relative" }}
          classes={{ root: this.props.classes.appBarRoot }}
        >
          <Toolbar classes={{ root: this.props.classes.toolbarRoot }}>
            <IconButton
              className={this.props.classes.menuButton}
              onClick={this.toggleDrawer(!this.state.drawerOpen)}
              color="inherit"
              aria-label="Menu"
            >
              <MenuIcon />
            </IconButton>
            <img
              src={getCurrentHost() === "crewmama" ? crewmamaLogo : Logo}
              alt={
                getCurrentHost() === "crewmama"
                  ? "Crew Mama"
                  : "Assignment Desk"
              }
              className={this.props.classes.logo}
              onClick={e => {
                if (window.location.pathname !== "/") {
                  this.props.history.push("/")
                }
              }}
            />
            {/* {window.location.host.indexOf("adesk") !== -1 && (
              <Typography
                variant="h5"
                className={this.props.classes.appTitle}
                color="#000000"
                onClick={e => {
                  if (window.location.pathname !== "/") {
                    this.props.history.push("/")
                  }
                }}
              >
                PRODUCTION CREW DIRECTORY
              </Typography>
            )} */}
            {/* <Manager>
                <Target>
                  <div ref={node => {
                    this.shootsDropdownTarget = node;
                  }}>
                  <div className={this.props.classes.switch} onClick={() => this.handleToggleDropdown('shoots')}>
                    <KeyboardArrowDownIcon className={this.props.classes.switchIcon}/>
                    <Typography variant="h5" color="inherit">
                      Company Name
                    </Typography>
                    <div className={this.props.classes.switchPlace}>
                      <PlaceIcon className={this.props.classes.placeIcon} />
                      <Typography variant="caption" className={this.props.classes.placeName} color="inherit">
                        Greenville, SC
                      </Typography>
                    </div>
                  </div>
                  </div>
                </Target>
                <Popper
                  placement="bottom-start"
                  eventsEnabled={this.state.shootsDropdownOpen}
                  className={classNames({ [this.props.classes.popperClose]: !this.state.shootsDropdownOpen })}
                >
                  <ClickAwayListener onClickAway={(event) => this.handleCloseDropdown(event,'shoots')}>
                    <Grow in={this.state.shootsDropdownOpen} id="menu-list-grow" style={{ transformOrigin: '0 0 0' }}>
                      <Paper>
                        <MenuList role="menu">
                          <MenuItem onClick={(event) => this.handleCloseDropdown(event,'shoots')}>Shoot Name 1</MenuItem>
                          <MenuItem onClick={(event) => this.handleCloseDropdown(event,'shoots')}>Shoot Name 2</MenuItem>
                          <MenuItem onClick={(event) => this.handleCloseDropdown(event,'shoots')}>Shoot Name 3</MenuItem>
                          <MenuItem onClick={(event) => this.handleCloseDropdown(event,'shoots')}>Shoot Name 4</MenuItem>
                        </MenuList>
                      </Paper>
                    </Grow>
                  </ClickAwayListener>
                </Popper>
              </Manager> */}
            <div className={this.props.classes.rightArea}>
              {/*<input id="searchTerm" placeholder="Search" className={this.props.classes.textField} value={this.state.searchTerm} onChange={this.handleChange('searchTerm')}/>*/}
              {/* <Manager>
                  <Target>
                    <div ref={node => {
                      this.userDropdownTarget = node;
                    }}>
                      <Chip
                        avatar={
                          <Avatar>
                            <FaceIcon />
                          </Avatar>
                        }
                        aria-owns={this.state.userDropdownOpen ? 'menu-list-grow' : null}
                        aria-haspopup="true"
                        label={`${this.props.authentication.authenticatedUser.first_name} ${this.props.authentication.authenticatedUser.last_name}`}
                        onDelete={() => this.handleToggleDropdown('user')}
                        onClick={() => this.handleToggleDropdown('user')}
                        deleteIcon={<KeyboardArrowDownIcon />}
                        classes={{ root: this.props.classes.chip, deleteIcon: this.props.classes.chipDeleteIcon }}
                      />
                    </div>
                  </Target>
                  <Popper
                    placement="bottom"
                    eventsEnabled={this.state.userDropdownOpen}
                    className={classNames({ [this.props.classes.popperClose]: !this.state.userDropdownOpen })}
                  >
                    <ClickAwayListener onClickAway={(event) => this.handleCloseDropdown(event,'user')}>
                      <Grow in={this.state.userDropdownOpen} id="menu-list-grow">
                        <Paper className={this.props.classes.userDropDownPaper}>
                          <MenuList role="menu">
                            <MenuItem onClick={(event) => this.handleCloseDropdown(event,'user',this.openProfile)}>Profile</MenuItem>
                            <MenuItem onClick={(event) => this.handleCloseDropdown(event,'user',this.doLogout)}>Logout</MenuItem>
                          </MenuList>
                        </Paper>
                      </Grow>
                    </ClickAwayListener>
                  </Popper>
                </Manager> */}
              <Typography
                variant="caption"
                color="default"
                style={{ color: "#000000" }}
                className="version"
              >
                {version}
              </Typography>
            </div>
          </Toolbar>
        </AppBar>
        {/* </header> */}
      </Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authentication: state.authentication,
    companies: state.companies,
    crew: state.crew,
  }
}

export default withRouter(
  compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToProps)
  )(MainAppBarComponent)
)
